/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upper_Ago_Mink_TrustInputs */

const fr_upper_ago_mink_trust = /** @type {(inputs: Upper_Ago_Mink_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

/**

* @param {Upper_Ago_Mink_TrustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const upper_ago_mink_trust = /** @type {((inputs?: Upper_Ago_Mink_TrustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upper_Ago_Mink_TrustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_upper_ago_mink_trust(inputs)
});